import { api } from "../utils/apiClient";
import { triggerDownload } from "../utils/downloadFile";

const FILENAME_FALLBACK = "report.pdf";

/**
 * Pull the filename out of a `Content-Disposition: attachment; filename="...".pdf` response header,
 * falling back to a generic name if the header is missing or malformed. Keeps the backend as the
 * single source of truth for naming instead of duplicating its logic client-side.
 *
 * @param {string | undefined} contentDisposition
 * @returns {string}
 */
const filenameFromContentDisposition = (contentDisposition) => {
  const match = contentDisposition?.match(/filename="?([^";]+)"?/i);
  return match ? match[1] : FILENAME_FALLBACK;
};

/**
 * Fetch a report's findings-only PDF from the backend and trigger a download.
 *
 * @param {"audit" | "llm_visibility" | "persona" | "ota_vs_direct" | "perception"} reportType
 * @param {string} reportId
 */
export const downloadReportPdf = async (reportType, reportId) => {
  const response = await api.get(`/reports/${reportType}/${reportId}/pdf`, false, {
    responseType: "blob",
  });
  const filename = filenameFromContentDisposition(response.headers["content-disposition"]);
  triggerDownload(response.data, filename);
};
